import type { TreatmentWithConfig as SplitTreatmentWithConfig } from '@splitsoftware/splitio/types/splitio';
import type { FeatureFlag } from '@surfline/map-lib';
import { getWindow } from '@surfline/web-common';
import { getUser } from 'common/api/user';
import {
  BW_IOS_OCEAN_CURRENTS_LAYER,
  BW_IOS_WIND_AND_CURRENTS_LAYER,
  SL_SURFTILER_ISOLINES,
  SL_SURFTILER_MODEL_SELECTOR,
  SL_SURFTILER_NEARSHORE,
} from 'common/treatments';
import type { WavetrakContext, WavetrakPageContext } from 'types/wavetrak';
import { getServerTreatments } from 'utils/serverSplitClient';

type Treatments = Record<string, string | SplitTreatmentWithConfig>;

export async function getSurftilerFeatureFlags(
  context: WavetrakPageContext,
): Promise<FeatureFlag[]> {
  const { req } = context;

  const user = await getUser(context as WavetrakContext, true);

  const isServer = !!req;
  const anonymousID = req?.cookies?.ajs_anonymous_id;

  const treatmentKeys = [
    SL_SURFTILER_NEARSHORE,
    SL_SURFTILER_ISOLINES,
    SL_SURFTILER_MODEL_SELECTOR,
    BW_IOS_OCEAN_CURRENTS_LAYER,
    BW_IOS_WIND_AND_CURRENTS_LAYER,
  ];
  const treatments: Treatments =
    anonymousID && isServer
      ? ((await getServerTreatments(treatmentKeys, user, anonymousID)) as Treatments)
      : (getWindow()?.__WAVETRAK_TREATMENTS__ as Treatments);
  return Object.entries(treatments || ({} as Treatments))
    .map(
      ([key, value]) =>
        ({
          key,
          value: value as string,
        }) as FeatureFlag,
    )
    .filter((flag) => flag.value === 'on' && treatmentKeys.includes(flag.key));
}
